// src/pages/Events2025.jsx
import React, { useState } from 'react';
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import Footer from '../components/footer';
import EventImageSlider from '../components/EventImageSlider';
import EventModal from '../components/EventModal';

// Images (update/convert HEIC to JPG/PNG if necessary for browser compatibility)
import Awarness1 from "../assets/Gallery/CyberJagrit/Awarness1.jpg";
import Awarness2 from "../assets/Gallery/CyberJagrit/Awarness2.jpg";
import Awarness3 from "../assets/Gallery/CyberJagrit/Awarness3.jpg";
import Awarness4 from "../assets/Gallery/CyberJagrit/Awarness4.jpg";
import Awarness5 from "../assets/Gallery/CyberJagrit/Awarness5.jpg";

import Memathon1 from "../assets/Gallery/CyberJagrit/Memathon1.jpg";
import Memathon2 from "../assets/Gallery/CyberJagrit/Memathon2.jpg";
import Memathon3 from "../assets/Gallery/CyberJagrit/Memathon3.jpg";
import Memathon4 from "../assets/Gallery/CyberJagrit/Memathon4.jpg";
import Memathon5 from "../assets/Gallery/CyberJagrit/Memathon5.jpg";

import Nukad1 from "../assets/Gallery/CyberJagrit/Nukad1.JPG";
import Nukad2 from "../assets/Gallery/CyberJagrit/Nukad2.JPG";
import Nukad3 from "../assets/Gallery/CyberJagrit/Nukad3.JPG";
import Nukad4 from "../assets/Gallery/CyberJagrit/Nukad4.JPG";
import Nukad5 from "../assets/Gallery/CyberJagrit/Nukad5.JPG";

import stimul1 from "../assets/Gallery/CyberJagrit/Stimulator1.jpg";
import stimul2 from "../assets/Gallery/CyberJagrit/Stimulator2.jpg";
import stimul3 from "../assets/Gallery/CyberJagrit/Stimulator3.jpg";
import stimul4 from "../assets/Gallery/CyberJagrit/Stimulator4.jpg";
import stimul5 from "../assets/Gallery/CyberJagrit/Stimulator5.jpg";

import quiz1 from "../assets/Gallery/CyberJagrit/IMG_20251016_110021.jpg";
import quiz2 from "../assets/Gallery/CyberJagrit/IMG_20251016_110036.jpg";
import quiz3 from "../assets/Gallery/CyberJagrit/IMG_2519.jpg";

// Dev-Spark images
import devspark1 from "../assets/Gallery/DevSpark/DEVSPARK1.jpg";
import devspark2 from "../assets/Gallery/DevSpark/DEVSPARK2.jpg";
import devspark3 from "../assets/Gallery/DevSpark/DEVSPARK3.jpg";
import devspark4 from "../assets/Gallery/DevSpark/DEVSPARK4.jpg";
import devspark5 from "../assets/Gallery/DevSpark/DEVSPAR5.jpg";
import devspark6 from "../assets/Gallery/DevSpark/DEVSPARK6.jpg";
import devspark8 from "../assets/Gallery/DevSpark/DEVSARK8.jpg";
import devspark10 from "../assets/Gallery/DevSpark/DEVSPARK10.jpg";
import devspark11 from "../assets/Gallery/DevSpark/DEVSAPRK11.jpg";
import devspark12 from "../assets/Gallery/DevSpark/DEVSAPRK12.jpg";
import devspark13 from "../assets/Gallery/DevSpark/DEVSAPRK13.jpg";
import devspark15 from "../assets/Gallery/DevSpark/DEVSPARK15.jpg";
import devspark16 from "../assets/Gallery/DevSpark/DEVSAPRK16.jpg";

// Hack-To-Hire images
import hacktohire1 from "../assets/Gallery/HackToHire/hack to hire1.jpg";
import hacktohire2 from "../assets/Gallery/HackToHire/hacktohire2.jpg";
import hacktohire3 from "../assets/Gallery/HackToHire/hacktohire3.jpg";
import hacktohire4 from "../assets/Gallery/HackToHire/hacktohire4.jpg";
import hacktohire5 from "../assets/Gallery/HackToHire/hacktohire5.jpg";
import hacktohire6 from "../assets/Gallery/HackToHire/hacktohire6.jpg";
import hacktohire7 from "../assets/Gallery/HackToHire/hacktohore7.jpg";
import hacktohire8 from "../assets/Gallery/HackToHire/hacktohire8.jpg";

// Image arrays
const cyberJagritAwarenessImages = [Awarness1, Awarness2, Awarness3, Awarness4, Awarness5];
const cyberJagritMemeathonImages = [Memathon1, Memathon2, Memathon3, Memathon4, Memathon5];
const cyberJagritSimulatorsImages = [stimul1, stimul2, stimul3, stimul4, stimul5];
const cyberJagritNukkadImages = [Nukad1, Nukad2, Nukad3, Nukad4, Nukad5];
const cyberJagritQuizImages = [quiz1, quiz2,quiz3];
const devSparkImages = [devspark1, devspark2, devspark3, devspark4, devspark5, devspark6, devspark8, devspark10, devspark11, devspark12, devspark13, devspark15, devspark16];
const hackToHireImages = [hacktohire1, hacktohire2, hacktohire3, hacktohire4, hacktohire5, hacktohire6, hacktohire7, hacktohire8];

const Events2025 = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleOpen = (eventKey) => setSelectedEvent(eventKey);
  const handleClose = () => setSelectedEvent(null);

  return (
    <>
      <Header />
      <Navbar />

      {/* Hack-To-Hire */}
      <div className="bg-gradient-to-br from-orange-50 to-amber-100 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)]
        border border-amber-200 mx-4 my-8 overflow-hidden transform transition-transform duration-300 hover:scale-[1.01]">
        <section className="px-6 pt-16 pb-6 bg-white text-center">
          <h4 className="text-2xl md:text-3xl font-bold mb-2 text-gray-800">
            <b>Hack-To-Hire (Jharkhand Edition) Ideathon</b>
          </h4>
          <p className="text-gray-600 text-lg mb-2">
            Organized by Trikaya in association with Department of CSE, CUJ and CSI Student Chapter
          </p>
          <p className="text-gray-700 text-base">
            <b>Date:</b> 13 November 2025 | <b>Venue:</b> Department of CSE, CUJ
          </p>
        </section>

        <section className="flex flex-col md:flex-row-reverse items-center gap-6 px-6 py-12 bg-amber-50">
          <div className="md:w-1/2 w-full">
            <EventImageSlider images={hackToHireImages} />
          </div>
          <div className="md:w-1/2 w-full">
            <h2 className="text-2xl md:text-3xl font-semibold text-amber-900 mb-2">Ideathon to National Evaluation Pipeline</h2>
            <p className="text-lg text-justify">
              The Ideathon served as the first qualifying round of Hack-To-Hire, where 15+ student teams pitched real-world solution ideas. Top teams progressed to national evaluation, prototype development, and potential final interviews in Bangalore.
            </p>
            <button className="mt-4 px-4 py-2 bg-amber-700 text-white rounded hover:bg-amber-800" onClick={() => handleOpen('hack_to_hire')}>
              Know More
            </button>
          </div>
        </section>
      </div>

      {/* Dev-Spark */}
      <div className="bg-gradient-to-br from-blue-50 to-cyan-100 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)]
        border border-cyan-200 mx-4 my-8 overflow-hidden transform transition-transform duration-300 hover:scale-[1.01]">
        <section className="px-6 pt-16 pb-6 bg-white text-center">
          <h4 className="text-2xl md:text-3xl font-bold mb-2 text-gray-800">
            <b>Dev-Spark</b>
          </h4>
          <p className="text-gray-600 text-lg mb-2">
            Department of CSE in collaboration with CSI Student Chapter, CUJ and GDG Ranchi
          </p>
          <p className="text-gray-700 text-base">
            <b>Date:</b> 18 September 2025
          </p>
        </section>

        <section className="flex flex-col md:flex-row items-center gap-6 px-6 py-12 bg-cyan-50">
          <div className="md:w-1/2 w-full">
            <EventImageSlider images={devSparkImages} />
          </div>
          <div className="md:w-1/2 w-full">
            <h2 className="text-2xl md:text-3xl font-semibold text-cyan-900 mb-2">Pre-DevFest Technical Enablement Event</h2>
            <p className="text-lg text-justify">
              Dev-Spark was designed to bridge classroom learning with real-world developer workflows through GDG community insights, Google Cloud hands-on training, and student readiness activities for DevFest 2025.
            </p>
            <button className="mt-4 px-4 py-2 bg-cyan-700 text-white rounded hover:bg-cyan-800" onClick={() => handleOpen('dev_spark')}>
              Know More
            </button>
          </div>
        </section>
      </div>

      {/* Cyber Jagrit: header card */}
      <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)]
        border border-gray-300 mx-4 my-8 overflow-hidden transform transition-transform duration-300 hover:scale-[1.01] hover:brightness-95">
        <section className="px-6 pt-16 pb-6 bg-white text-center">
          <h4 className="text-2xl md:text-3xl font-bold mb-2 text-gray-800">
            <b>Cyber Jagrit Bharat 2025</b>
          </h4>
          <p className="text-gray-600 text-lg mb-8">
            Organized by CSI Student Chapter – CUJ | <b>16th, 17th &amp; 26th October 2025</b>
          </p>
          <p className="text-gray-600 text-md max-w-4xl mx-auto">
            In collaboration with <b>Code Crafters Programming Club (CCPC)</b> &amp; <b>Department of Computer Science and Engineering (DCSE), CUJ</b>
          </p>
        </section>

        {/* Awareness Desk section (short front; details in modal) */}
        <section className="flex flex-col md:flex-row items-center gap-6 px-6 py-12 bg-indigo-50">
          <div className="md:w-1/2 w-full">
            <EventImageSlider images={cyberJagritAwarenessImages} />
          </div>
          <div className="md:w-1/2 w-full">
            <h2 className="text-2xl md:text-3xl font-semibold text-indigo-800 mb-2">Awareness Desk</h2>
            <h3 className="text-lg md:text-xl font-medium text-gray-600 mb-4">16th October 2025</h3>
            <p className="text-lg text-justify">
              Quick campus awareness on phishing, password safety, social media hygiene and data privacy. Volunteers engaged students with practical tips.
            </p>
            <button className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700" onClick={() => handleOpen('cyber_jagrit_awareness')}>
              Know More
            </button>
          </div>
        </section>
      </div>

      {/* Memeathon */}
      <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)]
        border border-gray-300 mx-4 my-8 overflow-hidden transform transition-transform duration-300 hover:scale-[1.01] hover:brightness-95">
        <section className="flex flex-col md:flex-row-reverse items-center gap-6 px-6 py-12 bg-white">
          <div className="md:w-1/2 w-full">
            <EventImageSlider images={cyberJagritMemeathonImages} />
          </div>
          <div className="md:w-1/2 w-full">
            <h2 className="text-2xl md:text-3xl font-semibold text-indigo-800 mb-2">Memeathon (Jointly organized by CSI &amp; CCPC)</h2>
            <h3 className="text-lg md:text-xl font-medium text-gray-600 mb-4">17th October 2025 (First Half)</h3>
            <p className="text-lg text-justify">
              A creativity-driven contest where students made memes about phishing, data leaks, fraud and cyberbullying. Entries were shared on CSI &amp; CCPC channels.
            </p>
            <button className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700" onClick={() => handleOpen('cyber_jagrit_memeathon')}>
              Know More
            </button>
          </div>
        </section>
      </div>

      {/* Simulators */}
      <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)]
        border border-gray-300 mx-4 my-8 overflow-hidden transform transition-transform duration-300 hover:scale-[1.01] hover:brightness-95">
        <section className="flex flex-col md:flex-row items-center gap-6 px-6 py-12 bg-indigo-50">
          <div className="md:w-1/2 w-full">
            <EventImageSlider images={cyberJagritSimulatorsImages} />
          </div>
          <div className="md:w-1/2 w-full">
            <h2 className="text-2xl md:text-3xl font-semibold text-indigo-800 mb-2">Simulators</h2>
            <h3 className="text-lg md:text-xl font-medium text-gray-600 mb-4">17th October 2025 (Second Half)</h3>
            <p className="text-lg text-justify">
              Controlled, ethical demos of common cyberattacks (mock data) with defensive steps — supervised and awareness-focused.
            </p>
            <button className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700" onClick={() => handleOpen('cyber_jagrit_simulators')}>
              Know More
            </button>
          </div>
        </section>
      </div>

      {/* Nukkad-Natak */}
      <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)]
        border border-gray-300 mx-4 my-8 overflow-hidden transform transition-transform duration-300 hover:scale-[1.01] hover:brightness-95">
        <section className="flex flex-col md:flex-row-reverse items-center gap-6 px-6 py-12 bg-white">
          <div className="md:w-1/2 w-full">
            <EventImageSlider images={cyberJagritNukkadImages} />
          </div>
          <div className="md:w-1/2 w-full">
            <h2 className="text-2xl md:text-3xl font-semibold text-indigo-800 mb-2">Nukkad-Natak (Street Play)</h2>
            <h3 className="text-lg md:text-xl font-medium text-gray-600 mb-4">17th October 2025 (Second Half)</h3>
            <p className="text-lg text-justify">
              A street play by DCSE students dramatizing phishing, fraud and online harassment — spreading the message: <b>Think Before You Click!</b>
            </p>
            <button className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700" onClick={() => handleOpen('cyber_jagrit_nukkad')}>
              Know More
            </button>
          </div>
        </section>
      </div>

      {/* Online Quiz */}
      <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)]
        border border-gray-300 mx-4 my-8 overflow-hidden transform transition-transform duration-300 hover:scale-[1.01] hover:brightness-95">
        <section className=" flex flex-col md:flex-row items-center gap-6 px-6 py-12 bg-white">
          <div className="md:w-1/2 w-full">
            <EventImageSlider images={cyberJagritQuizImages} />
          </div>
          <div className="md:w-1/2 w-full">
            <h2 className="text-2xl md:text-3xl font-semibold text-indigo-800 mb-2">Online Cyber Quiz</h2>
            <h3 className="text-lg md:text-xl font-medium text-gray-600 mb-4">26th October 2025</h3>
            <p className="text-lg text-justify">
              A 10-question online quiz testing cybersecurity laws, digital safety and responsibility. Time: 11:00 AM – 11:15 AM. Mode: Google Form.
            </p>
            <button className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700" onClick={() => handleOpen('cyber_jagrit_quiz')}>
              Know More
            </button>
          </div>
        </section>
      </div>

      {/* Impact + Media Combined */}
      <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)]
        border border-gray-300 mx-4 my-8 overflow-hidden transform transition-transform duration-300 hover:scale-[1.01] hover:brightness-95">
        <section className="px-6 pt-16 pb-6 bg-white text-center">
          <h4 className="text-2xl md:text-3xl font-bold mb-2 text-gray-800"><b>Impact, Outcomes & Media Coverage</b></h4>
          <p className="text-gray-600 text-lg mb-8">Highlights of Cyber Jagrit Bharat 2025</p>
        </section>

        <section className="flex flex-col md:flex-row items-start gap-10 px-6 py-12 bg-gray-100">
          <div className="md:w-1/2 w-full">
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-3">Impact & Outcomes</h2>
            <p className="text-lg text-gray-700 mb-4">The initiative strengthened cyber awareness and encouraged responsible digital habits across campus.</p>
            <ul className="list-disc pl-6 text-gray-700 text-lg space-y-1">
              <li>90% felt more cyber-aware</li>
              <li>Creative & practical participation</li>
              <li>Stronger CSI–CCPC–DCSE collaboration</li>
            </ul>
            <button onClick={() => handleOpen("impact")} className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Know More</button>
          </div>

          <div className="md:w-1/2 w-full">
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-3">Media Coverage</h2>
            <p className="text-lg text-gray-700 mb-4">The Hack-to-Hire Ideathon gained regional media attention, showcasing CUJ’s innovation.</p>
            <ul className="list-disc pl-6 text-gray-700 text-lg space-y-1">
              <li>Featured by 22Scope News</li>
              <li>Highlighted 15+ team participation</li>
              <li>Recognized for innovation & impact</li>
            </ul>
            <button onClick={() => handleOpen("media")} className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Know More</button>
          </div>
        </section>
      </div>

      {/* Thanks / Acknowledgements (short front) */}
      <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)]
        border border-gray-300 mx-4 my-8 overflow-hidden transform transition-transform duration-300 hover:scale-[1.01] hover:brightness-95">
        <section className="px-6 pt-12 pb-12 bg-white text-center">
          <h4 className="text-2xl md:text-3xl font-bold mb-2 text-gray-800"><b>Thanks & Acknowledgements</b></h4>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Gratitude to faculty, volunteers, clubs and participants whose enthusiasm made Cyber Jagrit Bharat 2025 a success.
          </p>
          <div className="mt-6">
            <button onClick={() => handleOpen('thanks')} className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">Know More</button>
          </div>
        </section>
      </div>

      <Footer />

      {/* Single EventModal for all details */}
      {selectedEvent && (
        <EventModal onClose={handleClose}>
          {/* Dev-Spark */}
          {selectedEvent === 'dev_spark' && (
            <>
              <h2 className="text-2xl font-bold mb-4">Dev-Spark — Detailed Report</h2>
              <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
                <p>
                  Dev-Spark was organized on <strong>18 September 2025</strong> by the Department of CSE, CUJ in collaboration with CSI Student Chapter and GDG Ranchi to bridge academic learning with practical industry workflows.
                </p>
                <p>
                  The event focused on Google Cloud fundamentals, community-driven development, and pre-DevFest readiness through expert sessions and hands-on guidance.
                </p>

                <h3 className="font-semibold">Core Objectives</h3>
                <ul className="list-disc pl-6">
                  <li>Enable practical understanding of Google Cloud credit usage and deployment workflows.</li>
                  <li>Promote hands-on learning beyond classroom tutorials.</li>
                  <li>Build awareness about GDG communities and global student opportunities.</li>
                  <li>Strengthen academic-industry collaboration for student growth.</li>
                </ul>

                <h3 className="font-semibold">Key Sessions</h3>
                <ul className="list-disc pl-6">
                  <li><strong>Opening Address:</strong> Aditya Ashish (President, CSI Student Council)</li>
                  <li><strong>GDG & DevFest Insights:</strong> Mr. Vickey Pandey (GDG Core Member)</li>
                  <li><strong>Google Cloud Workshop:</strong> Mr. Rajeev Singh (Backend Engineer, Revidd)</li>
                  <li><strong>Faculty Reflection:</strong> Dr. Kanojiya Sindhuben Babulal</li>
                </ul>

                <h3 className="font-semibold">Highlights</h3>
                <ul className="list-disc pl-6">
                  <li>Exclusive preview and orientation for DevFest 2025 participation.</li>
                  <li>Practical demonstration of Cloud Compute, storage, and application deployment.</li>
                  <li>Interactive technical quiz on Cloud, backend engineering, and GDG ecosystem.</li>
                </ul>

                <h3 className="font-semibold">Recognition</h3>
                <ul className="list-disc pl-6">
                  <li><strong>Special Contribution Award:</strong> Ujit Raj Rathore (Google Swag)</li>
                  <li><strong>Quiz Winner:</strong> Apurba Das (Free pass to GDG Ranchi DevFest 2025)</li>
                </ul>

                <p>
                  The event concluded with a vote of thanks by Apurba Das and successfully strengthened student confidence, technical exposure, and readiness for global-level developer communities.
                </p>
              </div>
            </>
          )}

          {/* Hack-To-Hire */}
          {selectedEvent === 'hack_to_hire' && (
            <>
              <h2 className="text-2xl font-bold mb-4">Hack-To-Hire Ideathon — Detailed Report</h2>
              <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
                <p>
                  The <strong>Hack-To-Hire (Jharkhand Edition) Ideathon</strong> was held on <strong>13 November 2025</strong> at the Department of CSE, CUJ as the preliminary round of a larger recruitment and innovation program by Trikaya.
                </p>

                <h3 className="font-semibold">Dignitaries and Delegates</h3>
                <ul className="list-disc pl-6">
                  <li>Trikaya delegates: Mr. Vickey Pandey and Mr. Harsh Raj</li>
                  <li>Felicitation by Prof. SC Yadav (HOD, CSE) and Prof. Ajai Singh (Dean, SOE)</li>
                  <li>Faculty presence including Dr. Kanojia Sindhuben Babulal, Dr. Pushpendra Kumar, Dr. Prashat Prashun, Ms. Supriya Gope and Ms. Tanupriya</li>
                </ul>

                <h3 className="font-semibold">Participation and Evaluation</h3>
                <p>
                  More than 15 teams presented innovative ideas spanning AI/ML applications, sustainable solutions and enterprise tools, followed by rigorous panel evaluation.
                </p>

                <h3 className="font-semibold">Top Teams</h3>
                <ul className="list-disc pl-6">
                  <li><strong>Winner:</strong> Team A^3N (Apurba, Abhishek, Ashish, Namrata)</li>
                  <li><strong>1st Runner-up:</strong> Team TEJAS (Aditya Ashish, Aditya Singh Chandel, Himani Pandey, Om Vishesh)</li>
                  <li><strong>2nd Runner-up:</strong> Team Technologia (Shashi Kumari Verma, Samriddhi Tripathi)</li>
                </ul>

                <h3 className="font-semibold">Next Competition Stages</h3>
                <ul className="list-disc pl-6">
                  <li><strong>Prototype submission deadline:</strong> 25 November 2025</li>
                  <li><strong>Grand Finale:</strong> 5 December 2025, Bangalore</li>
                  <li><strong>Final selection:</strong> Top 10 teams invited for direct interviews with companies/startups</li>
                  <li><strong>Support:</strong> Trikaya committed travel sponsorship for finalists</li>
                </ul>

                <p>
                  The Ideathon demonstrated strong student innovation and reinforced a practical academia-to-industry pathway through CSI CUJ, CSE Department, and Trikaya collaboration.
                </p>
              </div>
            </>
          )}

          {/* Awareness Details */}
          {selectedEvent === 'cyber_jagrit_awareness' && (
            <>
              <h2 className="text-2xl font-bold mb-4">Awareness Desk — Detailed</h2>
              <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
                <p>The campaign began with the Cyber Awareness Desk, managed by CSI & CCPC volunteers. The desk served as an informative hub, where pamphlets and posters were displayed on:</p>
                <ul className="list-disc pl-6">
                  <li>Safe internet practices</li>
                  <li>Phishing and email security</li>
                  <li>Password management</li>
                  <li>Social media awareness</li>
                  <li>Data privacy and digital footprints</li>
                </ul>
                <p>Students interacted with volunteers, cleared doubts and pledged to follow responsible cyber practices. The desk successfully reached a large number of students, marking an effective start.</p>
                <p><strong>Key Contributors:</strong> Abhimaan Kumar, Priyanshu Kumar, Mitthu Kumar</p>
              </div>
            </>
          )}

          {/* Memeathon */}
          {selectedEvent === 'cyber_jagrit_memeathon' && (
            <>
              <h2 className="text-2xl font-bold mb-4">Memeathon — Detailed</h2>
              <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
                <p>The CyberSec Memeathon (17th Oct 2025) encouraged students to express cybersecurity concepts through humor and design. Topics: phishing, data leaks, fraud, privacy breaches, cyberbullying.</p>

                <div className="bg-gray-50 p-3 rounded">
                  <p className="font-medium mb-2">Winners</p>
                  <table className="min-w-full text-left">
                    <thead>
                      <tr>
                        <th className="py-1 px-2 text-sm text-gray-600">Position</th>
                        <th className="py-1 px-2 text-sm text-gray-600">Name</th>
                        <th className="py-1 px-2 text-sm text-gray-600">Year</th>
                        <th className="py-1 px-2 text-sm text-gray-600">Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td className="py-1 px-2">🥇 1st</td><td className="py-1 px-2">Rishav Mishra</td><td className="py-1 px-2">3rd Year</td><td className="py-1 px-2">Excellent creativity</td></tr>
                      <tr><td className="py-1 px-2">🥈 2nd</td><td className="py-1 px-2">Keerti Lata Choudhury</td><td className="py-1 px-2">3rd Year</td><td className="py-1 px-2">Strong message delivery</td></tr>
                      <tr><td className="py-1 px-2">🥉 3rd</td><td className="py-1 px-2">Srishti Pathak</td><td className="py-1 px-2">3rd Year</td><td className="py-1 px-2">Innovative representation</td></tr>
                    </tbody>
                  </table>
                </div>

                <p><strong>Participants:</strong> ~150 students</p>
                <p><strong>Key Contributors:</strong> Aditya Ashish, Aditya Kumar, Krish Kumar</p>
              </div>
            </>
          )}

          {/* Simulators */}
          {selectedEvent === 'cyber_jagrit_simulators' && (
            <>
              <h2 className="text-2xl font-bold mb-4">Simulators — Detailed</h2>
              <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
                <p>Simulators (17th Oct 2025) provided controlled ethical demonstrations of cyberattacks and defenses using mock/isolated data — supervised by faculty.</p>

                <h3 className="font-semibold">Simulations Conducted</h3>
                <ol className="list-decimal pl-6 space-y-3">
                  <li><strong>Database Hacking</strong> — Focus: access control, encryption. Defense: least-privilege, backups, updates.</li>
                  <li><strong>Password Cracking</strong> — Focus: password risks. Defense: passphrases, managers, MFA.</li>
                  <li><strong>Endpoint Hacking</strong> — Focus: endpoint security. Defense: firewalls, updates, antivirus.</li>
                  <li><strong>Website Cloning (Phishing)</strong> — Focus: phishing recognition. Defense: verify authenticity, HTTPS.</li>
                  <li><strong>Brute Force (Controlled)</strong> — Conceptual demo; no live systems used. Defense: MFA, CAPTCHA, rate-limiting.</li>
                </ol>

                <h3 className="font-semibold mt-3">Ethical & Safety Measures</h3>
                <ul className="list-disc pl-6">
                  <li>Controlled, permission-based environments only.</li>
                  <li>No live data or institutional systems were used.</li>
                  <li>Faculty supervision ensured responsible demonstrations.</li>
                </ul>

                <p className="mt-2"><strong>Key Contributors:</strong> Manas Mani, Diwakar Singh, Mitthu Kumar</p>
              </div>
            </>
          )}

          {/* Nukkad */}
          {selectedEvent === 'cyber_jagrit_nukkad' && (
            <>
              <h2 className="text-2xl font-bold mb-4">Nukkad-Natak — Detailed</h2>
              <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
                <p>The Nukkad-Natak by DCSE students portrayed phishing, fraud and online harassment to deliver the message — <strong>Think Before You Click!</strong></p>
                <p><strong>Performers / Key Contributors:</strong> Apurba, Namrata, Siya, Dheeraj, Pawan, Raj Vardhan, Shashi, Samridhi, Priyanshi, Sanskar, Mohit, Pragati Priya, Ritika, Sonu, Aniket, Shreya</p>
              </div>
            </>
          )}

          {/* Quiz */}
          {selectedEvent === 'cyber_jagrit_quiz' && (
            <>
              <h2 className="text-2xl font-bold mb-4">Online Cyber Quiz — Detailed</h2>
              <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
                <p>The online quiz (26th Oct 2025, 11:00–11:15 AM) had 10 MCQs testing cybersecurity laws, digital safety and responsibility. Participants received e-certificates; top scorers were recognized.</p>
                <p><strong>Format:</strong> 10 MCQs — Mode: Google Form</p>
              </div>
            </>
          )}

          {/* Impact */}
          {selectedEvent === 'impact' && (
            <>
              <h2 className="text-2xl font-bold mb-4">Impact & Outcomes</h2>
              <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
                <p>The campaign achieved notable outcomes in enhancing awareness and building responsible habits.</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Increased awareness of cybersecurity risks and prevention.</li>
                  <li>Promoted creative expression and peer learning.</li>
                  <li>Strengthened collaboration between CSI, CCPC, and DCSE.</li>
                  <li>Introduced ethical hacking concepts responsibly.</li>
                  <li>Over <strong>90%</strong> of participants felt more confident identifying online threats (post-event survey).</li>
                </ul>
              </div>
            </>
          )}

          {/* Media */}
          {selectedEvent === 'media' && (
            <>
              <h2 className="text-2xl font-bold mb-4">Media Coverage & Public Outreach</h2>
              <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
                <p>The Hack-to-Hire Ideathon received regional coverage highlighting participation and innovation.</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Featured by <strong>22Scope News</strong></li>
                  <li>Participation of 15+ teams</li>
                  <li>Focus on logistics, cybersecurity and practical solutions</li>
                </ul>
                <p><strong >News Link:</strong><a href="https://22scope.com/hack-to-hire-ideathon-successfully-organized-in-cuj/">https://22scope.com/hack-to-hire-ideathon-successfully-organized-in-cuj/ </a></p>
              </div>
            </>
          )}

          {/* Thanks / Acknowledgements */}
          {selectedEvent === 'thanks' && (
            <>
              <h2 className="text-2xl font-bold mb-4">Thanks & Acknowledgements</h2>
              <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
                <p>The CSI CUJ Student Chapter extends sincere gratitude to everyone who contributed to Cyber Jagrit Bharat 2025.</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Dr. Kanojiya Sindhuben Babulal — Student Branch Coordinator, CSI CUJ Chapter</li>
                  <li>Dr. Subhash Chandra Yadav — Head, Department of Computer Science and Engineering</li>
                  <li>Faculty mentors and technical staff</li>
                  <li>Team CCPC for cooperation and collaboration</li>
                  <li>All student participants, volunteers, and coordinators</li>
                </ul>
                <p className="mt-2 font-medium">Presented by:<br />
                  <span className="text-indigo-800 font-bold">Computer Society of India (CSI), CUJ Student Chapter</span><br />
                  Department of Computer Science and Engineering, Central University of Jharkhand
                </p>
              </div>
            </>
          )}
        </EventModal>
      )}

    </>
  );
};

export default Events2025;
